import React from 'react';
import { Box, Button, CircularProgress, Stack, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import MeterForm from '../components/MeterForm';
import { useGetMeterHandler } from '../dataHandlers/getMeterHandler';
import TopBar from '../../../components/TopBar';

export default function MeterDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { meter, isLoading } = useGetMeterHandler(id);
  const theme = useTheme();

  if (isLoading || !meter) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box>
        <TopBar title="Meter Details" subTitle={meter?.meter_id} identifier={meter?.meter_id}>
          <Button
            data-testid="meter-profile-back-button"
            key="back"
            variant="contained"
            color="primary"
            onClick={() => navigate('/meters')}
            className="action-button"
            sx={{ marginLeft: theme.spacing(1) }}
          >
            Back
          </Button>
        </TopBar>
      </Box>
      <MeterForm readOnly={true} initialData={meter} onCancel={() => navigate('/meters')} />
    </Stack>
  );
}
